import { render } from "./ButiranNotisDialog.vue?vue&type=template&id=5d0b5de0"
import script from "./ButiranNotisDialog.vue?vue&type=script&lang=js"
export * from "./ButiranNotisDialog.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__